<script lang="ts">
import { OpportunityService } from '~/services/opportunity.service'
import { Opportunity } from '~/models/Opportunity'
import OpportunityOrganization from '~/components/I3pComponent/opportunities/entity/OpportunityOrganization.vue'
import OrganizationData = App.Data.Organization.OrganizationData

export default {
    name: 'OpportunityOrganizations',
    components: { OpportunityOrganization },
    props: {
        opportunityData: { type: Object, required: true },
        currentIntentionK: { type: String, required: false, default: null },
    },
    emits: ['selectIntentionK'],
    data() {
        return {
            opportunityService: null as OpportunityService,
        }
    },
    computed: {
        myOrganization(): OrganizationData | null {
            return (this.opportunityData as OpportunityData).organizations.find((organization) => {
                return organization.id === this.$currentUser()?.organization?.id
            })
        },
        notMyOrganization(): OrganizationData[] {
            return (this.opportunityData as OpportunityData).organizations.filter((organization) => {
                return organization.id !== this.$currentUser()?.organization?.id
            })
        },
    },
    watch: {
        opportunityData() {
            this.opportunityService = new OpportunityService(new Opportunity(this.opportunityData))
        },
    },
    beforeMount() {
        this.initService()
    },
    methods: {
        initService(): void {
            this.opportunityService = new OpportunityService(new Opportunity(this.opportunityData))
        },
    },
}
</script>

<template>
    <OpportunityOrganization v-if="myOrganization" :organization-data="myOrganization" :opportunity-data="opportunityData" :current-intention-k @select-intention-k="$emit('selectIntentionK', $event)" />

    <template v-for="organization in notMyOrganization" :key="organization.id">
        <OpportunityOrganization :organization-data="organization" :opportunity-data="opportunityData" :current-intention-k @select-intention-k="$emit('selectIntentionK', $event)" />
    </template>
</template>
